<template>
  <div>
    <el-row type="flex" justify="space-between" class="title-bar">
      <div>
        <el-radio-group v-model="tableType" class="mr-r10">
          <el-radio label="standard">기본</el-radio>
          <el-radio label="expand">확장</el-radio>
        </el-radio-group>
      </div>
      <div class="vertical-center-box">
        <el-button v-if="tableType === 'expand'" class="mr-r5" size="small" type="primary" @click="onClickColumnSetting"> 컬럼 설정 </el-button>
        <el-button class="mr-r5" size="small" @click="onClickExportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px">  엑셀출력</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool"/>
      </div>
    </el-row>
    <el-row>
      <el-table-wrapper
        v-loading="isLoading"
        ref="controllerTable"
        border
        :data="tableDatas"
        :columns="columns"
        :show-custom-header="true"
        :show-search-tool="showSearchTool"
        :pagination="true"
        :remote="true"
        :total="tableTotal"
        :column-default="columnDefault"
        :header-cell-class-name="headerCellClassName"
        @condition-change="onChangeTable"
      >
        <template v-for="column in dynamicColumnsArr" slot-scope="scope" :slot="column.scopedSlot">
          <span v-if="scope.row[column.id]">
            <el-tooltip effect="dark" placement="bottom">
              <span slot="content">
                <div style="overflow: hidden; text-overflow: ellipsis;" v-for="(item, index) in (scope.row[column.id]).split(',')" :key="index">
                  {{item}}
                </div>
              </span>
              <span>
                <div style="overflow: hidden; text-overflow: ellipsis;" v-for="(item, index) in (scope.row[column.id]).split(',')" :key="index">
                  {{item}}
                </div>
              </span>
            </el-tooltip>
          </span>
          <span v-else>-</span>
        </template>
        <template #obj-name-slot="scope">
          <span v-if="scope.row.objName" class="link c-pointer" @click="clickObjName(scope.row)">{{scope.row.objName}}</span>
          <span v-else>-</span>
        </template>
      </el-table-wrapper>
    </el-row>
    <w-device-list-column-set-popup ref="columnSetPopup" @reload-data="loadStore"></w-device-list-column-set-popup>
  </div>
</template>

<script>
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import { mapGetters } from 'vuex';
import { isEmpty, isNil, cloneDeep, forEach } from 'lodash';
import { columnDefault } from '@/constants/table';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';
import { objtype } from '@/constants/objtype';
import { getDateToString } from '@/utils/date';
import msgUtil from '@/utils/message';
import fileApi from '@/api/common/file';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import wirelessAPI from '@/api/config/wireless-device/wireless-device-info';
import WDeviceListColumnSetPopup from '../../netdevice/components/popup/DeviceListColumnSetPopup';

export default {
  name: 'WControllerConfigTable',
  components: {
    WDeviceListColumnSetPopup,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      columnDefault,
      tableType: 'standard',
      isLoading: false,
      showSearchTool: false,
      tableDatas: [],
      tableTotal: 0,
      columns: [],
      standardColumns: [
        {
          prop: 'objName',
          label: '장비명',
          scopedSlot: 'obj-name-slot',
          headerAlign: 'center',
          sortable: true,
          searchable: true,
          remoteProp: 'o.obj_name',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ipaddress',
          label: 'IP',
          headerAlign: 'center',
          sortable: true,
          searchable: true,
          width: 120,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objProductId',
          remoteProp: 'o.obj_product_id',
          label: '모델명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objCompanyName',
          remoteProp: 'oc.obj_company_name',
          label: '제조사',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'osVersion',
          remoteProp: 'ov.attr_value',
          label: 'OS 버전',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'serialNumber',
          remoteProp: 'sn.attr_value',
          label: '시리얼 넘버',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'majorManagerName',
          remoteProp: 'major.manager_name',
          label: '관리자 (정)',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'netdeviceUptimeCount',
          label: '구동 시간',
          sortable: true,
          searchable: false,
          formatter: this.convertNetdeviceUptime,
        },
        {
          prop: 'eolDate',
          remoteProp: 'opi.eol_date',
          label: '단종일-일시',
          sortable: true,
          searchable: true,
          searchType: 'date',
          formatter: this.convertDatetime,
        },
        {
          prop: 'eosDate',
          remoteProp: 'opi.eos_date',
          label: '서비스 종료일-일시',
          sortable: true,
          searchable: true,
          searchType: 'date',
          formatter: this.convertDatetime,
        },
      ],
      params: {
        managegroupIds: null,
      },
      expandColumns: [
        { prop: 'objName', scopedSlot: 'obj-name-slot', width: 180, remoteProp: 'o.obj_name', label: '장비명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'ipaddress', width: 120, label: 'IP', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'objtypeName', label: '장비종류', remoteProp: 'ot.objtype_name', sortable: true, searchable: true, width: 120, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'objCompanyName', remoteProp: 'oc.obj_company_name', label: '제조사', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'objProductId', remoteProp: 'o.obj_product_id', label: '모델명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
      ],
      dynamicColumnsArr: [],
    };
  },
  computed: {
    customerId() {
      return this.$store.state.common.customerId;
    },
    ...mapGetters(['selectedNode', 'selectedObjDefineIds', 'selectedObjDefineIdsForPhysical']),
  },
  watch: {
    selectedNode: {
      handler() {
        if (this.$refs.controllerTable === undefined) {
          this.$nextTick(() => {
            this.loadStore();
          });
        } else {
          this.loadStore();
        }
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
    /**
     * 애플망고 SKCC - 기본/확장 라디오 버튼에 제공 및 확장 테이블의 경우 설정한 동적컬럼에 따라 테이블 변환, 제공
     * @author Song
     */
    tableType: {
      handler(value) {
        this.columns = [];
        this.$nextTick(() => {
          // 테이블 컬럼을 변경하면서 기존 필터링 정보를 초기화한다.
          this.$refs.controllerTable.clearFilter();
          this.columns = value === 'standard' ? cloneDeep(this.getStandardColumns()) : cloneDeep(this.expandColumns);
          this.loadStore();
        });
      },
      immediate: true,
    },
  },
  methods: {
    onChangeTable() {
      this.loadStore();
    },
    /**
     * 컨트롤러 구성 정보를 조회한다.
     * @author yelim
     * @return {[type]} [description]
     */
    loadStore(reload) {
      if (this.active) {
        const treeType = this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
        const tableParams = this.$refs.controllerTable.getParameter();
        const params = {
          ...this.params,
          ...tableParams,
          managegroupIds: this.selectedNode.childManagegroupIds,
          treeType,
          customerId: this.tableType === 'expand' ? this.customerId : null,
          tableType: this.tableType,
          objtypeId: objtype.AP_CONTROLLER,
          managetypeId: this.selectedNode.managetypeId,
        };
        if (!isEmpty(this.selectedObjDefineIds)) {
          params.objDefineIds = this.selectedObjDefineIds;
        }
        if (reload) {
          this.columns = [];
          this.$refs.controllerTable.clearFilter();
          this.columns = cloneDeep(this.expandColumns);
          this.$nextTick(() => {
            this.getConfigTemplateColums();
          });
        } else if (this.tableType === 'expand') {
          this.columns = [];
          this.columns = cloneDeep(this.expandColumns);
          this.getConfigTemplateColums();
        }
        wirelessAPI
          .getControllerConfigInfoList(params)
          .then((response) => {
            if (response.data.success) {
              this.tableDatas = response.data.data;
              this.tableTotal = response.data.total;
            }
          })
          .catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '컨트롤러 구성 정보', false));
            throw new Error(e);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    clickObjName(row) {
      if (!isNil(row.obj_id)) {
        routePathByObjId(this, row.obj_id, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
    convertDatetime(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value);
    },
    convertNetdeviceUptime(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return `${value}일`;
    },
    /**
     * 컨트롤러 구성정보를 엑셀 출력한다.
     * @author yelim
     * @return {[type]} [description]
     */
    onClickExportExcel() {
      const treeType = this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
      const tableParams = this.$refs.controllerTable.getParameter();
      const params = {
        ...this.params,
        ...tableParams,
        managegroupIds: this.selectedNode.childManagegroupIds,
        treeType,
        customerId: this.tableType === 'expand' ? this.customerId : null,
        tableType: this.tableType,
        objtypeId: objtype.AP_CONTROLLER,
        managetypeId: this.selectedNode.managetypeId,
      };
      if (!isEmpty(this.selectedObjDefineIds)) {
        params.objDefineIds = this.selectedObjDefineIds;
      }
      wirelessAPI
        .exportControllerConfigInfoDeviceList(params)
        .then((response) => {
          if (response.data.success && response.data.data) {
            fileApi.downloadExportedExcelFile(response.data.data);
          }
        });
    },
    /**
     * SKCC - 구성 설정 동적컬럼 생성, 해당 바인딩 변수는 template 반복하여 slot을 동적으로 생성한다.
     *
     * @author {Song}
     * @return {[type]} [description]
     */
    getConfigTemplateColums() {
      netdeviceInfoAPI.getConfigTemplateColumns().then((res) => {
        if (res.data.success) {
          const dynamicColumnsTemp = [];
          forEach(res.data.data, (item) => {
            const dynamicColumns = {
              id: item.columnId,
              label: item.columnName,
              width: item.columnSize,
              formatter: this.getTableValueAfterCheckEmpty,
              scopedSlot: item.columnId,
            };
            dynamicColumnsTemp.push(dynamicColumns);
            this.columns.push(dynamicColumns);
          });
          this.dynamicColumnsArr = cloneDeep(dynamicColumnsTemp);
        }
      });
    },
    /**
     * SKCC - customerId에 따라 standardColumns를 동적으로 반환.
     *
     * @author {Najong}
     * @return {[type]} [description]
     */
    getStandardColumns() {
      return this.standardColumns.filter((item) => isNil(item.customerId) || (!isNil(item.customerId) && item.customerId === this.customerId));
    },
    onClickColumnSetting() {
      // 팝업 생성
      this.$refs.columnSetPopup.open();
    },
    headerCellClassName() {
      return 'expand-column-header-style';
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/config/group/wireless/components/ControllerConfigTable.vue